import React from 'react';
import { Form, Button } from 'react-bootstrap';
import ReactSelect from 'react-select';
import { useFormik } from 'formik';
import useTranslate from 'hooks/useTranslate';
import { searchBlogInitialValues } from 'constants/schemaValidations/blogSchema';
import { useBlogCategoriesQuery } from 'services';

export const FilterForm: React.FC<any> = ({ onApplyFilters }) => {
	const { translate } = useTranslate();
	const { data: { data: categories = [] } = {} } = useBlogCategoriesQuery();

	const formik = useFormik({
		initialValues: searchBlogInitialValues,
		enableReinitialize: true,
		onSubmit: async (values) => {
			onApplyFilters(values?.keyword, values?.categoryId);
		},
	});

	return (
		<Form className="d-flex flex-column flex-lg-row gap-2 gap-md-3" onSubmit={formik.handleSubmit}>
			<Form.Group className="user-search">
				<div className="position-relative w-100">
					<i className="ri-search-line position-absolute"></i>

					<Form.Control
						className="rounded-pill"
						type="search"
						placeholder={translate('PlaceHolder.searchByKeyword')}
						name="keyword"
						autoComplete="off"
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
						value={formik.values.keyword}
					/>
				</div>
			</Form.Group>
			<Form.Group className="select-search position-relative">
				<ReactSelect
					isSearchable
					isClearable
					name="categoryId"
					options={categories}
					getOptionValue={(option) => option.id}
					getOptionLabel={(option) => option.attributes.Name}
					onChange={(optionValue: any) => formik.setFieldValue('categoryId', optionValue?.id)}
					onBlur={formik.handleBlur}
					autoFocus={false}
					placeholder={translate('PlaceHolder.selectIndustry')}
					className="form-react-select "
					classNamePrefix="select"
					value={categories?.find((item: any) => item.id === Number(formik.values.categoryId))}
				/>
				<i className="ri-function-line form-left-icon position-absolute"></i>
			</Form.Group>
			<Button className="filled-btn rounded-pill" type="submit">
				{translate('Button.search')}
			</Button>
		</Form>
	);
};

export default FilterForm;
